"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeakPanel = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var SpeakPanel = /** @class */ (function (_super) {
    __extends(SpeakPanel, _super);
    function SpeakPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.textInputRef = React.createRef();
        _this.handleTextChange = _this.handleTextChange.bind(_this);
        return _this;
    }
    SpeakPanel.prototype.componentDidMount = function () {
        var _this = this;
        document.onkeydown = function (ev) {
            if (ev.keyCode === 13 && _this.textInputRef.current && document.activeElement === _this.textInputRef.current) {
                _this.props.requestSpeak();
                return true;
            }
            return true;
        };
    };
    SpeakPanel.prototype.handleTextChange = function (e) {
        if (e.target.value) {
            this.props.setSpeakText(e.target.value);
        }
        else {
            this.props.setSpeakText('');
        }
    };
    SpeakPanel.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.InputGroup, null,
                React.createElement(reactstrap_1.Input, { type: "text", className: "bg-secondary text-light", innerRef: this.textInputRef, value: this.props.textToSpeak, disabled: this.props.requestingSpeak, onChange: this.handleTextChange, placeholder: "Type something to say through the robot's text to speech engine" }),
                React.createElement(reactstrap_1.InputGroupAddon, { addonType: "append" },
                    React.createElement(reactstrap_1.Button, { color: "secondary", className: "bg-secondary text-light border-light", disabled: this.props.requestingSpeak || !this.props.textToSpeak, onClick: function () { return _this.props.requestSpeak(); } }, "Say!")))));
    };
    ;
    return SpeakPanel;
}(React.PureComponent));
exports.SpeakPanel = SpeakPanel;
//# sourceMappingURL=SpeakPanel.js.map